import React from "react";

interface MultiFanVisualisationProps {
    svg: string | null;
    error: string;
}

export function MultiFanVisualisation({ svg, error }: MultiFanVisualisationProps) {
    return (
        <>
            <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "10px" }}>
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "auto",
                        minHeight: "600px"
                    }}
                >
                    {svg ? (
                        <div dangerouslySetInnerHTML={{ __html: svg }} />
                    ) : !error ? (
                        <p style={{ color: "#999", fontSize: "14px" }}>Naciśnij "Oblicz" aby wygenerować wizualizację</p>
                    ) : null}
                </div>
            </div>

            <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#f5f5f5", borderRadius: "4px", fontSize: "12px", gridColumn: "1 / -1" }}>
                <strong>Legenda: </strong>
                <span style={{ color: "#333333" }}>█</span> - Chłodnica (linia przerywana)&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ color: "#0099ff" }}>●</span> - Wentylator (koło)&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ color: "#000000" }}>●</span> - Punkt obserwacyjny (czarna kropka)
            </div>
        </>
    );
}
